import { gql, QueryResult, useQuery } from "@apollo/client";

import {
  CommentQuery,
  CommentQueryResult,
} from "../../../generated/gql/graphql";

const GET_ASSET_COMMENTS = gql`
  query Comments($query: CommentQuery) {
    comments(query: $query) {
      items {
        id
        userId
        status
        sort
        assetId
        parentId
        comment
        dateCreated
        dateUpdated
      }
      totalCount
      limit
      offset
      page
    }
  }
`;

export default function useAssetComments(
  query?: CommentQuery
): QueryResult<CommentQueryResult> {
  return useQuery<CommentQueryResult>(GET_ASSET_COMMENTS, {
    variables: {
      query,
    },
  });
}
